var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTrainLogoKtx20 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 50,
  height: 20,
  viewBox: "0 0 50 20"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#013691",
  d: "M13.142 4 6.983 8.173l.68-.911L8.631 4H3.928L0 17h4.648l1.56-4.845.63-.432L8.922 17h4.704l-2.861-7.683 3.83-2.535 3.88.049L15.518 17h4.704L23.18 6.878h4.461L32.297 17H37l-3.976-8.874-2.206.582 1.527-1.974L31.133 4z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#C11740",
  d: "M23 17h4.786S37.257 3 49 1c0 0-14.403-.292-26 16"
}))));
export default SvgTrainLogoKtx20;